import { render, staticRenderFns } from "./StylishDropdown.vue?vue&type=template&id=20fd948d&scoped=true"
import script from "./StylishDropdown.vue?vue&type=script&lang=js"
export * from "./StylishDropdown.vue?vue&type=script&lang=js"
import style0 from "./StylishDropdown.vue?vue&type=style&index=0&id=20fd948d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd948d",
  null
  
)

export default component.exports